import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BarrioContext } from '../components/BarrioContext';
import Dashboard2 from '../components/Dashboard2';
import { Button } from 'primereact/button';
import { useTerminologia } from '../hooks/useTerminologia';
import LoadingOverlay from '../components/LoadingOverlay';

const HOST_API = process.env.REACT_APP_URL;

// Prototipo de reorganizacion del Portal Barrio (ver Dashboard2.js), aislado en su
// propia ruta /portal2 para probar sin afectar el /portal actual.
const PortalBarrio2 = () => {
    const { seleccionarBarrio } = useContext(BarrioContext);
    const navigate = useNavigate();
    const t = useTerminologia();

    const administracionId = parseInt(localStorage.getItem('administracionId') || '1');
    const barriosPermitidos = JSON.parse(localStorage.getItem('barriosPermitidos') || '[]');

    const [listo, setListo] = useState(false);
    const [barriosDisponibles, setBarriosDisponibles] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (barriosPermitidos.length === 0) {
            navigate('/tableBarrios');
            return;
        }

        const fetchBarrios = async () => {
            try {
                const promises = barriosPermitidos.map(id =>
                    axios.get(`${HOST_API}api/barrios/GetBarrios`, {
                        params: { barrioId: id, administracionId }
                    })
                );
                const results = await Promise.all(promises);
                const barrios = results.flatMap(r => r.data).filter(Boolean);

                if (barrios.length === 0) {
                    setError(`No se encontraron los ${t.barrios} asignados.`);
                    return;
                }

                if (barrios.length === 1) {
                    const b = barrios[0];
                    seleccionarBarrio(
                        b.barrioId, b.nombreBarrio, b.cuit,
                        b.direccion, b.razonSocial, b.numeroCuenta,
                        b.cuentaBancaria, b.tipoCuentaBancaria, b.alias
                    );
                    setListo(true);
                } else {
                    setBarriosDisponibles(barrios);
                }
            } catch (err) {
                setError(`Error al cargar los ${t.barrios}. Intentá nuevamente.`);
            }
        };

        fetchBarrios();
    }, []);

    const elegirBarrio = (b) => {
        seleccionarBarrio(
            b.barrioId, b.nombreBarrio, b.cuit,
            b.direccion, b.razonSocial, b.numeroCuenta,
            b.cuentaBancaria, b.tipoCuentaBancaria, b.alias
        );
        setListo(true);
    };

    if (error) {
        return (
            <div style={{ padding: '3rem', textAlign: 'center' }}>
                <p style={{ color: '#e53e3e', marginBottom: '1rem' }}>{error}</p>
                <Button label="Volver al login" icon="pi pi-sign-in" onClick={() => navigate('/login')} />
            </div>
        );
    }

    if (barriosDisponibles.length > 1 && !listo) {
        return (
            <div style={{ padding: '3rem', textAlign: 'center' }}>
                <h2 style={{ color: '#1a3c5e', marginBottom: '0.5rem' }}>Seleccioná tu {t.barrio}</h2>
                <p style={{ color: '#666', marginBottom: '2rem' }}>Tu usuario tiene acceso a más de un {t.barrio}.</p>
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                    {barriosDisponibles.map(b => (
                        <Button key={b.barrioId} label={b.nombreBarrio} icon="pi pi-map-marker" onClick={() => elegirBarrio(b)} style={{ minWidth: '160px' }} />
                    ))}
                </div>
            </div>
        );
    }

    if (!listo) {
        return <LoadingOverlay visible />;
    }

    return <Dashboard2 />;
};

export default PortalBarrio2;
